import React from "react";
import styled from "styled-components";
 
const Footer = () => (
  <StyledFooter>
    <StyledHeader>react-spring-lightbox</StyledHeader>
    <LinkContainer>
      <StyledLink
        href="https://github.com/tim-soft/react-spring-lightbox"
        target="_blank"
        rel="noopener noreferrer"
      >
       
        GitHub
      </StyledLink>
      <StyledLink
        href="https://codesandbox.io/s/react-spring-lightbox-mosaic-71hts?fontsize=14&module=%2Fsrc%2FImageGallery%2Findex.js"
        target="_blank"
        rel="noopener noreferrer"
      >
        
        Codesandbox
      </StyledLink>
    </LinkContainer>
    <LinkContainer>
      <StyledLink
        href="https://timellenberger.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://timellenberger.com
      </StyledLink>
    </LinkContainer>
  </StyledFooter>
);

export default Footer;

const StyledHeader = styled.h2`
  margin: 20px 0;
`;

const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 20px 0;
`;

const StyledLink = styled.a`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.pageContentFontColor};
  margin: 0 5px;
  :hover {
    color: ${({ theme }) => theme.pageContentLinkHoverColor};
  }
  svg {
    margin-right: 5px;
  }
`;

const StyledFooter = styled.footer`
  position: absolute;
  padding: 0px 20px;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${({ theme }) => theme.pageBackgroundColor};
  color: ${({ theme }) => theme.pageContentFontColor};
  border-color: ${({ theme }) => theme.pageContentLinkHoverColor};
  border-style: solid;
  border-width: 1px;
  border-radius: 8px;
`;
